import LegalLayout from "@/components/legal/LegalLayout";

const H2 = ({ children }) => (
  <h2 className="font-display text-3xl md:text-4xl tighter text-white mt-14 mb-5 leading-tight">
    {children}
  </h2>
);
const H3 = ({ children }) => (
  <h3 className="font-body font-semibold text-lg md:text-xl text-white/90 mt-8 mb-3">
    {children}
  </h3>
);
const P = ({ children }) => <p>{children}</p>;
const UL = ({ children }) => (
  <ul className="list-disc pl-6 space-y-2 marker:text-[#FF6B1A]">{children}</ul>
);
const PH = ({ children }) => (
  <span className="font-mono text-[13px] tracking-[0.06em] uppercase text-[#FF6B1A]/90 bg-[#FF6B1A]/10 border border-[#FF6B1A]/25 rounded px-2 py-[3px]">
    {children}
  </span>
);

export default function CookiePolicy() {
  return (
    <LegalLayout eyebrow="Cookie Policy" title="Cookie Policy" updated="Gennaio 2026">
      <P>
        La presente Cookie Policy descrive le tipologie di cookie e strumenti di tracciamento utilizzati sul sito Modo Motori
        (di seguito, "il Sito"), gestito da <strong className="text-white">Delta Pictures S.r.l.</strong>, e le modalità con cui
        l'utente può gestirli, in conformità con il Regolamento (UE) 2016/679 (GDPR) e con le Linee Guida del Garante Privacy
        del 10 giugno 2021.
      </P>

      <H2>1. Cosa sono i cookie</H2>
      <P>
        I cookie sono piccoli file di testo che i siti visitati inviano al terminale (computer, tablet, smartphone) dell'utente,
        dove vengono memorizzati per essere poi ritrasmessi agli stessi siti alla successiva visita. Analoga funzione è svolta da
        altri strumenti di tracciamento (pixel, SDK, storage locale, ecc.).
      </P>

      <H2>2. Tipologie di cookie utilizzati</H2>

      <H3>a) Cookie tecnici (non richiedono consenso)</H3>
      <P>
        Sono strettamente necessari al funzionamento del Sito e all'erogazione dei servizi richiesti dall'utente
        (es. mantenere lo stato di navigazione, garantire la sicurezza del Sito, memorizzare le preferenze di visualizzazione).
        Ne è consentito l'uso senza il consenso preventivo dell'utente.
      </P>

      <H3>b) Cookie di terze parti — YouTube</H3>
      <P>
        Il Sito integra contenuti video pubblicati sul canale YouTube di Modo Motori. Quando la sezione con gli embed video viene
        caricata, YouTube (Google Ireland Ltd.) può installare cookie sul dispositivo dell'utente per finalità di funzionamento
        del player e — se attivate — di statistica e personalizzazione. Il Sito utilizza il dominio{" "}
        <code className="bg-white/[0.05] px-1.5 py-0.5 rounded text-white/85">youtube-nocookie.com</code>, che riduce il numero di
        cookie installati fino all'effettivo avvio del video.
      </P>
      <UL>
        <li>
          Informativa YouTube:{" "}
          <a href="https://policies.google.com/privacy" target="_blank" rel="noreferrer noopener" className="text-[#FF6B1A] hover:underline">
            policies.google.com/privacy
          </a>
        </li>
      </UL>

      <H3>c) Cookie analitici — solo se attivati</H3>
      <P>
        Il Sito può integrare in futuro strumenti di analisi statistica (es. Google Analytics 4, Meta Pixel) per comprendere in
        forma aggregata l'utilizzo del Sito. Tali strumenti verranno attivati previo consenso dell'utente tramite banner cookie.
        Al momento risultano attivi soltanto cookie tecnici e cookie di terze parti YouTube al momento della riproduzione video.
      </P>

      <H2>3. Come gestire i cookie</H2>
      <P>
        L'utente può in qualsiasi momento gestire le proprie preferenze relative ai cookie modificando le impostazioni del proprio
        browser. La disattivazione dei cookie tecnici può compromettere il corretto funzionamento del Sito.
      </P>
      <UL>
        <li>
          <a href="https://support.google.com/chrome/answer/95647" target="_blank" rel="noreferrer noopener" className="text-[#FF6B1A] hover:underline">Google Chrome</a>
        </li>
        <li>
          <a href="https://support.mozilla.org/it/kb/protezione-antitracciamento-avanzata-firefox-desktop" target="_blank" rel="noreferrer noopener" className="text-[#FF6B1A] hover:underline">Mozilla Firefox</a>
        </li>
        <li>
          <a href="https://support.apple.com/it-it/guide/safari/sfri11471/mac" target="_blank" rel="noreferrer noopener" className="text-[#FF6B1A] hover:underline">Apple Safari</a>
        </li>
        <li>
          <a href="https://support.microsoft.com/it-it/microsoft-edge/eliminare-i-cookie-in-microsoft-edge-63947406-40ac-c3b8-57b9-2a946a29ae09" target="_blank" rel="noreferrer noopener" className="text-[#FF6B1A] hover:underline">Microsoft Edge</a>
        </li>
      </UL>

      <H2>4. Titolare del trattamento e contatti</H2>
      <P>
        Titolare del trattamento è <strong className="text-white">Delta Pictures S.r.l.</strong>, con sede legale in{" "}
        <strong className="text-white">Via G. Boglietti 2, 13900 Biella</strong>, P.IVA{" "}
        <strong className="text-white">02154000026</strong>, Cap. Soc. € 50.000 i.v. Per esercitare i propri diritti in materia di cookie e dati
        personali, o per richieste specifiche, l'utente può scrivere a{" "}
        <a href="mailto:privacy@modomotori.it" className="text-[#FF6B1A] hover:underline">privacy@modomotori.it</a>.
      </P>

      <H2>5. Aggiornamenti della Cookie Policy</H2>
      <P>
        La presente Cookie Policy può essere aggiornata in qualsiasi momento in relazione all'evoluzione normativa o
        all'introduzione di nuovi strumenti. La versione in vigore è quella pubblicata su questa pagina.
      </P>
    </LegalLayout>
  );
}
